module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"export":"Exportieren","exportAndSetAsCompleted":"Exportieren und abschließen","new":"Neu","receipts":"Belege"},"en":{"export":"Export","exportAndSetAsCompleted":"Export and set as completed","new":"New","receipts":"Receipts"}}')
  delete Component.options._Ctor
}
